import { fetchProductsFromClerk } from '../utils/clerk-recommendations';

export default (node) => {
  const clerkKey = node.getAttribute('data-clerk-key');
  const clerkUpsellLimit = node.getAttribute('data-clerk-upsell-limit');
  const clerkRecommendationsUrl = node.getAttribute('data-clerk-recommendations-url');
  const moneyFormat = node
    .getAttribute('data-money-format')
    .replace('amount_with_dot_separator', 'amount');
  const selectSize = node.getAttribute('data-select-size');
  const addToCartText = node.getAttribute('data-add-to-cart-text');
  const loadingText = node.getAttribute('data-loading-text');

  const init = () => {
    fetchProductsFromClerk(document.querySelectorAll('[data-cart-main-content] [data-cart-item]'), clerkRecommendationsUrl, clerkKey, clerkUpsellLimit, false, moneyFormat, selectSize, addToCartText, document.querySelector('[data-main-cart-title]'), '[data-main-cart-drawer-products]', '[data-cart-drawer-sell-products-mobile-embla]', '["Upsell - Main cart"]', loadingText);
    document.addEventListener('main-cart:update', () => fetchProductsFromClerk(document.querySelectorAll('[data-cart-main-content] [data-cart-item]'), clerkRecommendationsUrl, clerkKey, clerkUpsellLimit, false, moneyFormat, selectSize, addToCartText, document.querySelector('[data-main-cart-title]'), '[data-main-cart-drawer-products]', '[data-cart-drawer-sell-products-mobile-embla]', '["Upsell - Main cart"]', loadingText));
  };

  init();
};
